import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'shared-circle-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './circle-loader.component.html',
  styleUrl: './circle-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircleLoaderComponent {
  static NorecordsFoundComponent: readonly any[] | Type<any>;
}
